/* Built In Imports */
/* External Imports */
import { Box, Heading, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import SimpleButton from '@msr/components/Buttons/SimpleButton';
import StructuredTextParser from '@msr/Utility/StructuredTextParser';

/* Services */

/**
 * Renders the Attend In Person Banner Section component
 *
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region for the Section
 * @param {string} lang - Language for the Section
 * @returns {ReactElement} - AttendInPersonBanner Section Component
 */

export const SummarySection = ({ section, lang }) => {
  return (
    <Box
      backgroundImage={section?.styleConfig?.bgImage?.url}
      bgRepeat="repeat"
      width="100%"
      minH={{ base: 'auto', sm: '271px', lg: '136.56px' }}
      display="flex"
      flexDir="column"
      justifyContent="center"
    >
      <Box ml={{ base: 'auto', md: '50px', lg: '50px' }}>
        <StructuredTextParser
          str={render(section?.sectionContent[0]?.body)}
          color="#FFF7E9"
          fontWeight={'400'}
          maxW={{
            base: '100%',
            sm: '56%',
            md: '52%',
            lg: lang == 'ta' ? '62%' : '55%',
          }}
          fontFamily={lang == 'ta' ? 'MuktaMalar' : 'FedraSansStd-book'}
          pageName="tamilthembu"
          textAlign="center"
          className="desctext"
        />
      </Box>
      <style jsx global>
        {`
          .desctext p {
            line-height: 27.2px;
          }
        `}
      </style>
    </Box>
  );
};
